// Only reuse the exact report/filter response, never aggregate non-additive metrics in the browser.
export function createReportResponseCache(now = Date.now) {
  const entries = new Map<string, { value: unknown; until: number }>();
  const pending = new Map<string, Promise<unknown>>();
  let generation = 0;
  return {
    clear() { generation += 1; entries.clear(); pending.clear(); },
    async get<T extends { delivery?: { status: string; expiresAt: string } }>(key: string, load: () => Promise<T>): Promise<T> {
      const cached = entries.get(key);
      if (cached && cached.until > now()) return cached.value as T;
      if (pending.has(key)) return pending.get(key) as Promise<T>;
      const started = generation;
      const request = load().then(value => {
        const expiry = Date.parse(value.delivery?.expiresAt || "");
        const until = value.delivery?.status === "stale" ? now() + 15_000 : Math.min(now() + 300_000, expiry);
        if (started === generation && Number.isFinite(until) && until > now()) {
          if (entries.size >= 12) entries.delete(entries.keys().next().value!);
          entries.set(key, { value, until });
        }
        return value;
      }).finally(() => { if (started === generation) pending.delete(key); });
      pending.set(key, request);
      return request;
    }
  };
}
